import axios, { AxiosError, Method } from 'axios';
import ApiServiceError from 'support/ApiServiceError';
import { HttpOptions } from './CwApiClient';
import { AppData } from '@lightningjs/sdk';

export const Endpoints = {
  QR_ACCESS_TOKEN: '/sso/mobile/token',
  GENERATE_QR_CODE_TOKEN: '/sso/mobile/generate',
} as const;

export type LrClientOptions = HttpOptions & { useSiteUrl?: boolean };

export default class LoginRadiusApiClient {
  async request<TResponse = unknown>(
    method: Method,
    url: string,
    options?: LrClientOptions,
  ) {
    const endpoints = AppData?.config?.login.endpoints;
    const siteUrl = endpoints?.login_radius_hub;
    const baseUrl = endpoints?.login_radius_cloud;

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...options?.headers,
    };

    try {
      return await axios.request<TResponse>({
        baseURL: options?.useSiteUrl ? siteUrl : baseUrl,
        url,
        method,
        headers,
        data: options?.data,
        params: options?.params,
        responseType: 'json',
      });
    } catch (e) {
      throw new ApiServiceError(e as AxiosError, url);
    }
  }
}
